// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#data_box[data-v-19319a41] {\n  background-color: #34363C;\n  border-radius: 4px;\n}\n#data_people_box[data-v-19319a41] {\n  background-color: #5C5D62;\n  border-radius: 4px;\n}\n#data_sub_title[data-v-19319a41] {\n  color: #CECED0;\n  font-size: 0.8rem;\n}\n#data_count[data-v-19319a41] {\n  font-weight: bold;\n}\n#middle_divider[data-v-19319a41] {\n  background-color: #4C4C4C;\n}", ""]);
// Exports
module.exports = exports;
